/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Plant_UnlockedInputs */

const en_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Plant Unlocked!`)
};

const ar_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم فتح نبتة جديدة`)
};

const de_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Pflanze freigeschaltet!`)
};

const es_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Nueva planta desbloqueada!`)
};

const fr_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle plante débloquée !`)
};

const it_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova pianta sbloccata!`)
};

const ja_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい植物がアンロックされました！`)
};

const ko_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로운 식물이 잠금 해제됐어요!`)
};

const pt_br_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova planta desbloqueada!`)
};

const ru_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокировано новое растение!`)
};

const th_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกต้นไม้ใหม่แล้ว!`)
};

const tr_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni Bitkinin Kilidi Açıldı!`)
};

const zh_cn_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁新植物！`)
};

const zh_tw_new_plant_unlocked = /** @type {(inputs: New_Plant_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解鎖新植物！`)
};

/**
* | output |
* | --- |
* | "New Plant Unlocked!" |
*
* @param {New_Plant_UnlockedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const new_plant_unlocked = /** @type {((inputs?: New_Plant_UnlockedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Plant_UnlockedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_plant_unlocked(inputs)
	if (locale === "ar") return ar_new_plant_unlocked(inputs)
	if (locale === "de") return de_new_plant_unlocked(inputs)
	if (locale === "es") return es_new_plant_unlocked(inputs)
	if (locale === "fr") return fr_new_plant_unlocked(inputs)
	if (locale === "it") return it_new_plant_unlocked(inputs)
	if (locale === "ja") return ja_new_plant_unlocked(inputs)
	if (locale === "ko") return ko_new_plant_unlocked(inputs)
	if (locale === "pt_br") return pt_br_new_plant_unlocked(inputs)
	if (locale === "ru") return ru_new_plant_unlocked(inputs)
	if (locale === "th") return th_new_plant_unlocked(inputs)
	if (locale === "tr") return tr_new_plant_unlocked(inputs)
	if (locale === "zh_cn") return zh_cn_new_plant_unlocked(inputs)
	return zh_tw_new_plant_unlocked(inputs)
});